module.exports = __webpack_public_path__ + "omniv2/img/value-add.0c0c895e.jpg";